/*eslint-disable */
const $ = window.jQuery = require('jquery');  
import toast from '@/services/toast';
import countries from '@/services/country.json';
import allCountries from './phoneCodeList.json';
import { Datetime } from 'vue-datetime';
import { VueEditor } from "vue2-editor";
import Multiselect from 'vue-multiselect'
// You need a specific loader for CSS files
import 'vue-datetime/dist/vue-datetime.css'
import {
  mapGetters
} from 'vuex';
export default {
  name: 'interview-promote',
  components: {
    Multiselect,
    datetime: Datetime,
    VueEditor
  },
  props: [],
  data () {
    return {
      submitted:false,
      fullName:'',
      email:'',
      phone: {
        number: '',
        isValid: false,
        countryIso: '',
        countryCode:''
      },
      allCountriesList:[],
      countryList:[],
      interview_date:'',
      file:null,
      uploadAttachmentName:'',
      comment:'',
      editorOptions: {
        placeholder: '',
        editorToolbar: ['bold','italic','link',  '|', 'heading', 'fontFamily','fontSize','undo','redo']
      },
      editorData: '',
      interviewInfo:null,
      new_interview_date:'',
      newDateBox:false,
      round_1:true,
      round_2:false,
      round_3:false,
      round_4:false,
      round_5:false,
      roundstep_2:false,
      roundstep_3:false,
      roundstep_4:false,
      roundstep_5:false,
      status:false,
      userList:null,
      userListResults:[],
      options:[],
      users:[],
      sentUserData:[],
      minDatetime:new Date().toISOString(),
      finalStatus:''
    }
  },
  computed: {
    ...mapGetters([
      'interviewInfoByIdGetters'
    ]),
    getInterviewInfoByIdFun() {
      this.interviewInfo = this.$store.getters.interviewInfoByIdGetters.data
      return
    },
    setIntialStates(){
      if(this.interviewInfo){
        this.fullName = this.interviewInfo.name
        this.email = this.interviewInfo.email
        this.interview_date = this.interviewInfo.interview_date
        this.uploadAttachmentName = this.interviewInfo.file_name
        this.round_1 = this.interviewInfo.round_1
        this.round_2 = this.interviewInfo.round_2
        this.round_3 = this.interviewInfo.round_3
        this.status = this.interviewInfo.status
        this.phone.countryCode = this.interviewInfo.mobile_country_code
        this.phone.number = this.interviewInfo.mobile
        // this.users = this.interviewInfo.interviewer_id
        setTimeout(()=>{
          if(this.phone.countryCode != null && this.phone.countryCode != ''){
            var countrySplit = this.phone.countryCode
            var phoneCountry = countrySplit.replace('+', '');
            this.phone.countryIso = this.allCountriesList.filter(item => item.dialCode == phoneCountry)[0].iso2;
            }
        },100)
      }
      return
    }
  },
  mounted () {
    this.$store.dispatch('getInterviewerListFun').then((res) => {
      this.userList = res.data.data
      if(this.userList){
        this.userListResults = this.userList.results
        for(var i = 0; i < this.userListResults.length; i++){
          this.options.push({first_name:this.userListResults[i].first_name,last_name:this.userListResults[i].last_name,email:this.userListResults[i].email, id : this.userListResults[i].id})
        }
      }
    })
    this.getInterviewInfoByIdFun
    this.setIntialStates
    Object.keys(countries).map((key, index) => {
      this.countryList.push({
        name: countries[key].toLowerCase(),
        value: key.toLowerCase()
      })
    });
    this.countryList.sort((a, b) => (a.name > b.name) ? 1 : -1)
    for (var i = 0; i < allCountries.length; i++) {
      let c = allCountries[i];
      this.allCountriesList.push({
        name: c[0],
        iso2: c[1],
        dialCode: c[2],
        priority: c[3] || 0,
        areaCodes: c[4] || null
      });
    }
  },
  methods: {
    chooseCountry(country) { 
      this.phone.countryIso = country.iso2;
      this.phone.countryCode = country.dialCode
    },
    validateBeforeSubmit(e) {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.submitted = true;
          this.sentUserData = []
          for(var i = 0; i < this.users.length; i++){
            this.sentUserData.push(this.users[i].id)
          }
          var formData = new FormData();
          formData.append('name', this.fullName);
          formData.append('email', this.email);
          formData.append('interview_date', this.interview_date);
          formData.append('file_name', this.uploadAttachmentName);
          formData.append('mobile_country_code', this.phone.countryCode);
          formData.append('mobile', this.phone.number);
          formData.append('remarks', this.comment);
          formData.append('status', this.status);
          formData.append('parent', this.$route.params.promoteID);
          formData.append('interviewer_id', this.sentUserData);
          if(this.status){
            formData.append('is_completed', true);
            if(this.finalStatus == 'selected'){
              formData.append('is_not_selected', false);
              formData.append('is_selected', true);
            }else{
              formData.append('is_not_selected', true);
              formData.append('is_selected', false);
            }
          }
          this.$store.dispatch('createInterviewInfoFun', formData)
          .then((res) => {  
              this.submitted = false;
              toast.success(res.data.msg);            
              this.$router.push({ name: 'employeeList'})
          }).catch((err) => {
              this.submitted = false;
              toast.error(err.data.user_msg || err.data.msg);
          })
          return;
        }
      });
    },
    clearUploadedFileForModelTrainerMethod(){
      this.file = null
      this.uploadAttachmentName = ''
    },
    handleAttachmentUpload(event) {
      if(event.target.files && event.target.files.length > 0) {
        this.file = event.target.files[0];
        this.files = this.$refs.file.files[0];
        this.uploadAttachmentName = this.files.name
      }else {
        this.uploadAttachmentName = '';
      }
    },
  },
  watch:{
    getInterviewInfoByIdFun() {
      return this.$store.getters.interviewInfoByIdGetters
    },
    setIntialStates(){
      if(this.interviewInfo){
        this.fullName = this.interviewInfo.name
        this.email = this.interviewInfo.email
        this.interview_date = this.interviewInfo.interview_date
        this.uploadAttachmentName = this.interviewInfo.file_name
        this.phone.countryCode = this.interviewInfo.mobile_country_code
        this.phone.number = this.interviewInfo.mobile
        this.comment = this.interviewInfo.comment
        this.round_1 = this.interviewInfo.round_1
        this.round_2 = this.interviewInfo.round_2
        this.round_3 = this.interviewInfo.round_3 
        this.status = this.interviewInfo.status
        setTimeout(()=>{
          if(this.phone.countryCode != null && this.phone.countryCode != ''){
            var countrySplit = this.phone.countryCode
            var phoneCountry = countrySplit.replace('+', '');
            this.phone.countryIso = this.allCountriesList.filter(item => item.dialCode == phoneCountry)[0].iso2;
            }
        },100)
      }
      return
    },
  }
}